const ProgressBar = ({ percentage, progressName, progressStatus }) => {
  const fillerStyles = {
    width: `${percentage * 100}%`,
  };

  return (
    <div className="progress-bar">
      <div className="progress-label-top">
        {progressName}
      </div>

      {["Hyperjet", "Express"].includes(progressName) && (
        <div className={`progress-container ${progressName.toLowerCase()}`}>
  
          <div className="progress-line">
            <div className={percentage === 1 ? 'filler filler-completed' : 'filler'} style={fillerStyles}></div>
          </div>

          {progressName === "Hyperjet" && (
            <div className="disc-middle"></div>
          )}

        </div>

      )}
      <div className="progress-label-bottom">
        {progressStatus}
      </div>
    </div>
  );
};

export default ProgressBar;


